const LiveChatFooter = (props: { extra?: string }) => {
    const { extra } = props;

    const openWhatsAppSupport = () => {
        const phoneNumber = "33756958621"; // WhatsApp phone number in international format (without +)
        const message = encodeURIComponent("Bonjour, j'ai besoin d'aide");
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

        window.open(whatsappUrl, "_blank");
    };

    return (
        <div className={`mt-3 flex justify-center mx-auto gap-2 ${extra}`}>
            <p className="text-xs">Need help ?</p>
            <div className="flex gap-3 my-auto" onClick={openWhatsAppSupport}>
                <p className="text-xs font-medium text-primary cursor-pointer">
                    Our live support is online
                </p>
            </div>
        </div>
    );
};

export default LiveChatFooter;
